export default function CreateChinaMapLine() {
  let pts = [];
  let pt1 = new BMap.Point(124.326919, 39.841287);
  pts.push( pt1);
  let pt2 = new BMap.Point(124.630475, 40.230192);
  pts.push( pt2);
  let pt3 = new BMap.Point(124.980023, 40.420289);
  pts.push( pt3);
  let pt4 = new BMap.Point(125.053612, 40.458947);
  pts.push( pt4);
  let pt5 = new BMap.Point(125.028316, 40.520401);
  pts.push( pt5);
  let pt6 = new BMap.Point(125.331871, 40.63438);
  pts.push( pt6);
  let pt7 = new BMap.Point(125.456053, 40.61861);
  pts.push( pt7);
  let pt8 = new BMap.Point(126.042467, 40.901897);
  pts.push( pt8);
  let pt9 = new BMap.Point(126.888743, 41.73411);
  pts.push( pt9);
  let pt10 = new BMap.Point(127.367072, 41.437131);

  pts.push( pt10);
  let pt11 = new BMap.Point(128.148958, 41.347076);
  pts.push( pt11);
  let pt12 = new BMap.Point(128.323732, 41.568524);
  pts.push( pt12);
  let pt13 = new BMap.Point(128.112163, 41.961089);
  pts.push( pt13);
  let pt14 = new BMap.Point(128.995233, 41.99541);
  pts.push( pt14);
  let pt15 = new BMap.Point(129.418371, 42.378521);
  pts.push( pt15);
  let pt16 = new BMap.Point(129.841509, 42.41943);
  pts.push( pt16);
  let pt17 = new BMap.Point(130.080674, 42.90824);
  pts.push( pt17);
  let pt18 = new BMap.Point(130.65099, 42.364879);
  pts.push( pt18);
  let pt19 = new BMap.Point(130.503812, 42.637157);
  pts.push( pt19);
  let pt20 = new BMap.Point(131.147717, 42.867653);
  pts.push( pt20);

  let pt21 = new BMap.Point(131.313293, 43.366337);
  pts.push( pt21);
  let pt22 = new BMap.Point(131.386882, 43.967324);
  pts.push( pt22);
  let pt23 = new BMap.Point(131.202909, 44.798523);
  pts.push( pt23);
  let pt24 = new BMap.Point(131.938801, 45.190155);
  pts.push( pt24);
  let pt25 = new BMap.Point(133.024241, 44.916296);
  pts.push( pt25);
  let pt26 = new BMap.Point(134.385641, 47.183241);
  pts.push( pt26);
  let pt27 = new BMap.Point(134.845574, 47.670159);
  pts.push( pt27);
  let pt28 = new BMap.Point(134.73519, 48.066299);
  pts.push( pt28);
  let pt29 = new BMap.Point(135.250314, 48.434915);
  pts.push( pt29);
  let pt30 = new BMap.Point(133.079433, 48.115602);
  pts.push( pt30);

  let pt31 = new BMap.Point(132.453925, 47.76948);
  pts.push( pt31);
  let pt32 = new BMap.Point(131.221306, 47.707427);
  pts.push( pt32);
  let pt33 = new BMap.Point(130.85336, 48.078629);
  pts.push( pt33);
  let pt34 = new BMap.Point(130.908552, 48.825163);
  pts.push( pt34);
  let pt35 = new BMap.Point(128.093766, 49.632427);
  pts.push( pt35);
  let pt36 = new BMap.Point(125.830898, 53.063643);
  pts.push( pt36);
  let pt37 = new BMap.Point(123.420852, 53.60326);
  pts.push( pt37);
  let pt38 = new BMap.Point(120.661258, 53.240599);
  pts.push( pt38);
  let pt39 = new BMap.Point(119.906969, 52.584436);
  pts.push( pt39);
  let pt40 = new BMap.Point(120.698052, 52.494695);
  pts.push( pt40);

  let pt41 = new BMap.Point(120.734847, 52.05456);
  pts.push( pt41);
  let pt42 = new BMap.Point(119.023898, 50.296998);
  pts.push( pt42);
  let pt43 = new BMap.Point(119.263063, 50.143545);
  pts.push( pt43);
  let pt44 = new BMap.Point(117.956855, 49.560675);
  pts.push( pt44);
  let pt45 = new BMap.Point(116.889812, 49.858941);
  pts.push( pt45);
  let pt46 = new BMap.Point(115.47322, 48.078629);
  pts.push( pt46);
  let pt47 = new BMap.Point(115.988344, 47.607987);
  pts.push( pt47);
  let pt48 = new BMap.Point(116.797825, 47.76948);
  pts.push( pt48);
  let pt49 = new BMap.Point(117.349744, 47.520821);
  pts.push( pt49);
  let pt50 = new BMap.Point(117.901663, 47.905734);
  pts.push( pt50);

  let pt51 = new BMap.Point(118.508774, 47.893363);
  pts.push( pt51);
  let pt52 = new BMap.Point(118.545569, 47.86861);
  pts.push( pt52);
  let pt53 = new BMap.Point(119.888571, 46.843488);
  pts.push( pt53);
  let pt54 = new BMap.Point(119.796585, 46.590415);
  pts.push( pt54);
  let pt55 = new BMap.Point(119.005501, 46.717101);
  pts.push( pt55);
  let pt56 = new BMap.Point(117.791279, 46.526961);
  pts.push( pt56);
  let pt57 = new BMap.Point(117.404936, 46.310656);
  pts.push( pt57);
  let pt58 = new BMap.Point(116.797825, 46.323404);
  pts.push( pt58);
  let pt59 = new BMap.Point(116.282701, 45.798295);
  pts.push( pt59);
  let pt60 = new BMap.Point(114.700534, 45.384961);
  pts.push( pt60);

  let pt61 = new BMap.Point(113.670285, 44.759212);
  pts.push( pt61);
  let pt62 = new BMap.Point(112.161707, 45.04687);
  pts.push( pt62);
  let pt63 = new BMap.Point(111.444212, 44.298587);
  pts.push( pt63);
  let pt64 = new BMap.Point(111.959336, 43.767669);
  pts.push( pt64);
  let pt65 = new BMap.Point(110.082812, 42.569199);
  pts.push( pt65);
  let pt66 = new BMap.Point(107.543985, 42.39216);
  pts.push( pt66);
  let pt67 = new BMap.Point(105.115542, 41.609961);
  pts.push( pt67);
  let pt68 = new BMap.Point(100.405834, 42.596391);
  pts.push( pt68);
  let pt69 = new BMap.Point(96.560799, 42.772848);
  pts.push( pt69);
  let pt70 = new BMap.Point(91.188788, 45.203163);
  pts.push( pt70);

  let pt71 = new BMap.Point(89.992964, 47.893363);
  pts.push( pt71);
  let pt72 = new BMap.Point(87.969261, 49.115857);
  pts.push( pt72);
  let pt73 = new BMap.Point(86.847026, 49.055436);
  pts.push( pt73);
  let pt74 = new BMap.Point(85.724791, 48.201769);
  pts.push( pt74);
  let pt75 = new BMap.Point(85.301653, 47.05766);
  pts.push( pt75);
  let pt76 = new BMap.Point(83.167567, 47.23339);
  pts.push( pt76);
  let pt77 = new BMap.Point(82.284497, 45.52739);
  pts.push( pt77);
  let pt78 = new BMap.Point(82.652442, 45.177144);
  pts.push( pt78);
  let pt79 = new BMap.Point(81.769372, 45.346053);
  pts.push( pt79);
  let pt80 = new BMap.Point(79.911245, 44.890145);
  pts.push( pt80);

  let pt81 = new BMap.Point(80.702329, 43.20505);
  pts.push( pt81);
  let pt82 = new BMap.Point(80.003232, 42.077702);
  pts.push( pt82);
  let pt83 = new BMap.Point(77.096459, 41.05527);
  pts.push( pt83);
  let pt84 = new BMap.Point(76.158197, 40.369298);
  pts.push( pt84);
  let pt85 = new BMap.Point(75.753456, 40.594072);
  pts.push( pt85);
  let pt86 = new BMap.Point(74.925578, 40.48178);
  pts.push( pt86);
  let pt87 = new BMap.Point(73.803343, 39.605094);
  pts.push( pt87);
  let pt88 = new BMap.Point(73.637767, 39.291284);
  pts.push( pt88);
  let pt89 = new BMap.Point(73.913726, 38.457149);
  pts.push( pt89);
  let pt90 = new BMap.Point(74.612824, 38.500536);
  pts.push( pt90);

  let pt91 = new BMap.Point(74.999167, 37.31988);
  pts.push( pt91);
  let pt92 = new BMap.Point(77.924337, 35.325072);
  pts.push( pt92);
  let pt93 = new BMap.Point(78.273886, 34.598061);
  pts.push( pt93);
  let pt94 = new BMap.Point(79.101764, 34.293224);
  pts.push( pt94);
  let pt95 = new BMap.Point(78.770613, 33.987267);
  pts.push( pt95);
  let pt96 = new BMap.Point(79.230545, 32.472038);
  pts.push( pt96);
  let pt97 = new BMap.Point(78.880997, 32.59672);
  pts.push( pt97);
  let pt98 = new BMap.Point(78.421064, 32.425237);
  pts.push( pt98);
  let pt99 = new BMap.Point(78.844202, 31.18404);
  pts.push( pt99);
  let pt100 = new BMap.Point(81.180659, 29.990271);
  pts.push( pt100);

  let pt101 = new BMap.Point(81.71418, 30.34198);
  pts.push( pt101);
  let pt102 = new BMap.Point(86.092737, 27.935542);
  pts.push( pt102);
  let pt103 = new BMap.Point(88.760345, 27.951881);
  pts.push( pt103);
  let pt104 = new BMap.Point(88.99951, 27.197728);
  pts.push( pt104);
  let pt105 = new BMap.Point(89.845786, 28.098817);
  pts.push( pt105);
  let pt106 = new BMap.Point(91.538337, 27.772017);
  pts.push( pt106);
  let pt107 = new BMap.Point(92.108653, 26.769165);
  pts.push( pt107);
  let pt108 = new BMap.Point(93.893191, 26.851709);
  pts.push( pt108);
  let pt109 = new BMap.Point(95.916893, 28.115131);
  pts.push( pt109);
  let pt110 = new BMap.Point(97.223102, 27.690161);
  pts.push( pt110);

  let pt111 = new BMap.Point(97.609445, 28.375809);
  pts.push( pt111);
  let pt112 = new BMap.Point(98.363734, 27.427807);
  pts.push( pt112);
  let pt113 = new BMap.Point(98.73168, 26.653501);
  pts.push( pt113);
  let pt114 = new BMap.Point(97.646239, 24.702995);
  pts.push( pt114);
  let pt115 = new BMap.Point(97.627842, 23.842845);
  pts.push( pt115);
  let pt116 = new BMap.Point(98.658091, 23.944344);
  pts.push( pt116);
  let pt117 = new BMap.Point(98.970845, 23.045009);
  pts.push( pt117);
  let pt118 = new BMap.Point(99.449174, 22.89168);
  pts.push( pt118);
  let pt119 = new BMap.Point(99.21001, 21.96805);
  pts.push( pt119);
  let pt120 = new BMap.Point(99.982696, 21.933723);
  pts.push( pt120);

  let pt121 = new BMap.Point(100.166669, 21.366121);
  pts.push( pt121);
  let pt122 = new BMap.Point(101.086534, 21.589991);
  pts.push( pt122);
  let pt123 = new BMap.Point(101.730439, 21.055576);
  pts.push( pt123);
  let pt124 = new BMap.Point(101.969604, 21.31441);
  pts.push( pt124);
  let pt125 = new BMap.Point(101.804028, 22.190972);
  pts.push( pt125);
  let pt126 = new BMap.Point(102.53992, 22.53323);
  pts.push( pt126);
  let pt127 = new BMap.Point(103.956512, 22.447745);
  pts.push( pt127);
  let pt128 = new BMap.Point(105.465091, 23.130116);
  pts.push( pt128);
  let pt129 = new BMap.Point(107.819945, 21.435041);
  pts.push( pt129);
  let pt130 = new BMap.Point(108.408658, 20.588528);
  pts.push( pt130);

  let pt131 = new BMap.Point(108.243082, 17.791978);
  pts.push( pt131);
  let pt132 = new BMap.Point(110.101209, 14.556493);
  pts.push( pt132);
  let pt133 = new BMap.Point(109.82525, 10.162358);
  pts.push( pt133);
  let pt134 = new BMap.Point(108.151096, 6.074665);
  pts.push( pt134);
  let pt135 = new BMap.Point(109.604482, 3.416913);
  pts.push( pt135);
  let pt136 = new BMap.Point(113.136763, 3.712694);
  pts.push( pt136);
  let pt137 = new BMap.Point(115.362836, 6.737258);
  pts.push( pt137);
  let pt138 = new BMap.Point(117.404936, 9.505473);
  pts.push( pt138);
  let pt139 = new BMap.Point(119.318255, 14.574413);
  pts.push( pt139);
  let pt140 = new BMap.Point(120.164531, 19.12633);
  pts.push( pt140);

  let pt141 = new BMap.Point(122.059452, 21.693198);
  pts.push( pt141);
  let pt142 = new BMap.Point(122.813741, 24.686186);
  pts.push( pt142);
  let pt143 = new BMap.Point(124.230333, 28.457139);
  pts.push( pt143);
  let pt144 = new BMap.Point(124.855841, 32.721228);
  pts.push( pt144);
  let pt145 = new BMap.Point(124.230333, 36.56674);
  pts.push( pt145);
  let pt146 = new BMap.Point(124.487895, 39.59086);
  pts.push( pt146);

  return pts;
}
